import axios from 'axios'
import VueCookies from 'vue-cookies'
import { API_BASE } from './apiBase'

// Отдельный клиент для личного кабинета.
//
// Глобальный axios носит операторский токен: если ходить кабинетом через него,
// два входа в одном браузере перетирали бы заголовок друг друга, а операторский
// токен уезжал бы в клиентские адреса (и наоборот). Поэтому у кабинета свой
// экземпляр и своя кука.
export const CLIENT_TOKEN_COOKIE = 'client_token'

const clientApi = axios.create({ baseURL: API_BASE })

let onUnauthorized = null

// Обработчик 401 задаётся снаружи (в store), иначе получается кольцо импортов:
// store → clientApi → store.
export function setUnauthorizedHandler (handler) {
  onUnauthorized = handler
}

clientApi.interceptors.request.use((config) => {
  const token = VueCookies.get(CLIENT_TOKEN_COOKIE)

  if (token) config.headers.Authorization = token

  return config
})

clientApi.interceptors.response.use(
  response => response,
  (error) => {
    const url = (error.config && error.config.url) || ''
    const isLoginRequest = url.includes('/api/client/authenticate')

    if (error.response && error.response.status === 401 && !isLoginRequest && onUnauthorized) {
      onUnauthorized()
    }

    return Promise.reject(error)
  }
)

export default clientApi
